// const server_host = "http://192.168.3.4"
// const wss_port = "ws://192.168.3.4"

// const server_host = "http://192.168.1.135"
// const wss_port = "ws://192.168.1.135"
export const URL_CONFIG = {

    // 正式使用；
    "account_url": "https://account.toolup.cn",
    "agent_server_url": `https://ai.toolup.cn`,
    "im_url": "wss://ai.toolup.cn",
    "ws_url": "wss://ai.toolup.cn",

    // 本地用
    // "account_url": server_host, // 本地使用代理时使用
    // "agent_server_url": server_host,
    // "im_url": wss_port,

    "oss_url": "https://oss.toolup.cn",

    "translation_url": "http://toolup.cn:9999",

    "chat_url": "https://ai.toolup.cn",

    "conversations_url": "https://ai.toolup.cn",

    "file_processor_url": "http://toolup.cn:9998",
    // "file_processor_url": "https://ai.toolup.cn",   // 前端调试

    "sample_url": "http://toolup.cn:60666",

    "feedback_url": "http://192.168.3.35:8000",
}


